import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from 'ionic-angular';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SupportPanelComponent } from './components/support-panel/support-panel.component';
import {
  ServiceDeskTicketModalComponent
} from './components/service-desk-ticket-modal/service-desk-ticket-modal.component';

@NgModule({
  declarations: [
    SupportPanelComponent,
    ServiceDeskTicketModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxFileDropModule
  ],
  exports: [
    SupportPanelComponent
  ],
  entryComponents: [
    ServiceDeskTicketModalComponent
  ]
})
export class SupportModule {
}



// WEBPACK FOOTER //
// ./src/pages/support/support.module.ts